import routes from "../routes";
import _ from "lodash";
import { useLocation, Route, Switch } from "react-router-dom";
import React from "react";
import NotFound from "../views/404";

function ProfileLayout({profileData}) {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (_.includes(prop.path, "/dashboard/profile")) {
        return (
          <Route
            exact
            path={`${prop.path}`}
            render={(props) => <prop.component profileData={profileData} {...props} />}
            key={key}
          />
        );
      }
      return false;
    });
  };
  return (
    <Switch>
      {getRoutes(routes)}
      <Route path={`*`} component={NotFound} key="not-found" />
    </Switch>
  );
}

export default (ProfileLayout);
